import React, { useState, useEffect } from "react";
import Header from "../components/Navbar/Header";
import Navbar from "../components/Navbar";
import Footer from "../components/Navbar/Footer";
import Loader from "../Loader/Loader";
import { post, postupload } from "../utils/helpers/http";
import { toast, ToastContainer } from "react-toastify";
import useDebounce from "../hooks/useDebounce";

const Customers = () => {
  const [customers, setCustomers] = useState([]);
  const [totalRecords, setTotalRecords] = useState(0);
  const [pageNo, setPageNo] = useState(1);
  const [pageSize, setPageSize] = useState(10);
  const [searchKeyword, setSearchKeyword] = useState("");
  const [loader, setLoader] = useState(false);
  const [searchQuery, setSearchQuery] = useState("");

  const [showStatusModal, setShowStatusModal] = useState(false);
  const [statusChangeCustomer, setStatusChangeCustomer] = useState(null);

  const debouncedSearchQuery = useDebounce(searchQuery, 500);

  useEffect(() => {
    fetchCustomers();
  }, [pageNo, pageSize, searchKeyword]);

  const fetchCustomers = async () => {
    setLoader(true);
    try {
      let body = {
        pageNo: pageNo,
        pageSize: pageSize,
        searchKeyword: searchKeyword,
      };
      const response = await post("/Customer/CustomerList", body);
      console.log("response** customer list " + searchKeyword, response);
      if (response.data.data) {
        setCustomers(response.data.data.customers);
        setTotalRecords(response.data.data.totalRecords);
        console.log("if customer list");
      } else {
        setCustomers([]);
        setTotalRecords(0);
        console.log("else customer list []");
      }
    } catch (error) {
      setLoader(false);
    } finally {
      setLoader(false);
    }
  };
  useEffect(() => {
    if (debouncedSearchQuery.length >= 3) {
      setSearchKeyword(debouncedSearchQuery);
      setPageNo(1);
    } else if (debouncedSearchQuery.length === 0) {
      setSearchKeyword("");
      setPageNo(1);
    }
  }, [debouncedSearchQuery]);

  useEffect(() => {
    if (debouncedSearchQuery.length === 0) {
      fetchCustomers();
    }
  }, [debouncedSearchQuery]);

  const handleSearchChange = (e) => {
    // const value = e.target.value.trim();
    setSearchQuery(e.target.value?.trimStart());
  };
  const handlePageSizeChange = (e) => {
    const newSize = parseInt(e.target.value);
    setPageSize(newSize);
    setPageNo(1);
  };

  const handleExport = async () => {
    setLoader(true);
    try {
      let body = {
        pageNo: pageNo,
        pageSize: pageSize,
        searchKeyword: searchKeyword,
      };
      const response = await postupload(
        "/Customer/ExportCustomerToExcel",
        body,
        {
          responseType: "arraybuffer",
        },
      );
      if (response?.data) {
        const blob = new Blob([response.data], {
          type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
        });
        const url = window.URL.createObjectURL(blob);
        const link = document.createElement("a");
        link.href = url;
        link.setAttribute("download", "CustomerList.xlsx");
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
        window.URL.revokeObjectURL(url);
      } else {
        console.log("else customer list []");
      }
    } catch (error) {
      setLoader(false);
    } finally {
      setLoader(false);
    }
  };

  // Handle status toggle
  const handleToggleStatus = async (driverId, currentStatus) => {
    setStatusChangeCustomer({
      id: driverId,
      currentStatus: currentStatus,
      newStatus: !currentStatus,
    });
    setShowStatusModal(true);
  };

  // Confirm status change and call API
  const handleStatusChangeConfirmation = async () => {
    if (!statusChangeCustomer) return;

    setLoader(true);
    try {
      const response = await post(
        `/Account/ActivateDeactivateUserAccount?userId=${statusChangeCustomer.id}&isActive=${statusChangeCustomer.newStatus}`,
      );
      toast.dismiss();
      if (response.data.success || response.data.data) {
        fetchCustomers();

        toast.success(response.data.message);
      } else {
        toast.error(response.data.message);
      }
    } catch (error) {
      console.error("Error updating status:", error);
      toast.error("An error occurred while updating status");
    } finally {
      setLoader(false);
      setShowStatusModal(false);
      setStatusChangeCustomer(null);
    }
  };

  return (
    <>
      <Header />
      <div id="wrapper">
        <Navbar />
        <div id="content-wrapper">
          <div className="content_minArea">
            <div className="container-fluid">
              <div className="page-header">
                <div className="lefth">
                  <h1 className="page-title">Customer(s)</h1>
                </div>
              </div>
              <div className="page-content">
                <div className="page-content">
                  <div className="table-filters">
                    <div className="left_filters">
                      <div className="filterBox">
                        <label className="form-filter-label">Show</label>
                        <select
                          className="form-filter form-select"
                          onChange={handlePageSizeChange}
                          value={pageSize}
                        >
                          <option value={5}>5</option>
                          <option value={10}>10</option>
                          <option value={20}>20</option>
                        </select>
                        <label className="ps-2">entries</label>
                      </div>
                    </div>
                    <div className="right_filters">
                      <button
                        className="btn btn-primary tableBtnCss"
                        onClick={handleExport}
                      >
                        Export
                      </button>
                      <div className="searchBox">
                        <label>Search:</label>
                        <input
                          type="text"
                          className="form-filter"
                          placeholder="Search by Customer name, phone & email"
                          value={searchQuery}
                          onChange={handleSearchChange}
                        />
                      </div>
                    </div>
                  </div>
                  <div className="table-outerbox">
                    <table className="table">
                      <thead>
                        <tr>
                          <th width="20">SNo.</th>
                          <th width="20%">Customer Name</th>
                          <th width="25%">Email</th>
                          <th width="20%">Date of Birth</th>
                          <th width="20%">Phone</th>
                          <th width="20%">Postcode</th>
                          <th width="20%">Actions</th>
                        </tr>
                      </thead>
                      <tbody>
                        {customers.length ? (
                          customers.map((customer, index) => (
                            <tr key={index}>
                              <td>{(pageNo - 1) * pageSize + index + 1}</td>
                              <td>{`${customer.firstName} ${customer.lastName}`}</td>
                              <td>{customer.email || "-"}</td>
                              <td>{customer.dateOfBirth || "-"}</td>
                              <td>{customer.phoneNumber || "-"}</td>
                              <td>{customer.postCode || "-"}</td>
                              <td>
                                {" "}
                                <label
                                  className="custom-switch-button"
                                  title="Active"
                                >
                                  <input
                                    type="checkbox"
                                    checked={customer.isActive}
                                    onClick={() => {
                                      handleToggleStatus(
                                        customer.id,
                                        customer.isActive,
                                      );
                                    }}
                                  />
                                  <span className="slider"></span>
                                </label>
                              </td>
                            </tr>
                          ))
                        ) : loader ? (
                          ""
                        ) : (
                          <tr>
                            <td
                              colSpan="7"
                              style={{
                                textAlign: "center",
                                padding: "20px",
                                fontSize: "large",
                                fontWeight: "bold",
                              }}
                            >
                              No Data Found.
                            </td>
                          </tr>
                        )}
                      </tbody>
                    </table>
                  </div>
                </div>
                <div className="table-pagination">
                  <div className="leftpart">
                    <span className="entriesdata">
                      Showing {pageNo} to{" "}
                      {Math.min(pageNo * pageSize, totalRecords)} of{" "}
                      {totalRecords} entries{" "}
                    </span>
                  </div>
                  <div className="rightpart">
                    {customers.length > 0 && (
                      <div className="pagination_box">
                        <ul>
                          <li className="prev">
                            <button
                              onClick={() => setPageNo(Math.max(pageNo - 1, 1))}
                            >
                              <i className="fa-solid fa-chevron-left"></i>{" "}
                              Previous
                            </button>
                          </li>
                          {[
                            ...Array(Math.ceil(totalRecords / pageSize)).keys(),
                          ].map((page) => (
                            <li
                              key={page}
                              className={page + 1 === pageNo ? "current" : ""}
                            >
                              <button onClick={() => setPageNo(page + 1)}>
                                <span>{page + 1}</span>
                              </button>
                            </li>
                          ))}
                          <li className="next">
                            <button
                              onClick={() => {
                                const maxPage = Math.ceil(
                                  totalRecords / pageSize,
                                );
                                if (pageNo < maxPage) {
                                  setPageNo(pageNo + 1);
                                }
                              }}
                              disabled={
                                pageNo >= Math.ceil(totalRecords / pageSize)
                              }
                            >
                              Next <i className="fa-solid fa-chevron-right"></i>
                            </button>
                          </li>
                        </ul>
                      </div>
                    )}
                  </div>
                </div>
              </div>
            </div>
            {loader && <Loader />}
          </div>
          <Footer />
        </div>
      </div>

      {showStatusModal && statusChangeCustomer && (
        <div
          className="modal modal-center "
          tabIndex="-1"
          role="dialog"
          style={{ display: "block", backgroundColor: "rgba(0,0,0,0.5)" }}
        >
          <div className="modal-dialog" role="document">
            <div className="modal-content">
              <div className="modal-header">
                <h5 className="modal-title">Change Customer Status</h5>
                <button
                  type="button"
                  className="btn-close"
                  onClick={() => {
                    setShowStatusModal(false);
                    setStatusChangeCustomer(null);
                  }}
                ></button>
              </div>
              <div className="modal-body">
                <p>
                  Are you sure you want to{" "}
                  <strong>
                    {statusChangeCustomer.newStatus ? "activate" : "deactivate"}
                  </strong>{" "}
                  this Customer?
                </p>
              </div>
              <div className="modal-footer">
                <button
                  type="button"
                  className="btn btn-secondary"
                  onClick={() => {
                    setShowStatusModal(false);
                    setStatusChangeCustomer(null);
                  }}
                >
                  Cancel
                </button>
                <button
                  type="button"
                  className="btn btn-primary"
                  onClick={handleStatusChangeConfirmation}
                >
                  Yes,{" "}
                  {statusChangeCustomer.newStatus ? "Activate" : "Deactivate"}
                </button>
              </div>
            </div>
          </div>
        </div>
      )}

      <ToastContainer />
    </>
  );
};

export default Customers;
